import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Switch from '@components/switch/Switch'

const SwitchesSection = () => {
  const [leftValue, setLeftValue] = React.useState(true)

  return (
    <Section>
      <SectionTitle>Switches</SectionTitle>
      <Row>
        <View>
          <Switch value={leftValue} onChange={() => setLeftValue(!leftValue)} />
        </View>
        <View>
          <Switch disabled value={leftValue} onChange={() => setLeftValue(!leftValue)} />
        </View>
      </Row>
    </Section>
  )
}

export default SwitchesSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Row = styled(View)<{ dark?: boolean }>`
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: center;
`
